export type NegotiationSidebarReadiness = {
  orgOnboardingComplete: boolean;
  hasOrgAvatar: boolean;
  paymentMethodReady: boolean;
  hallSettlementMode?: "prepaid" | "legacy";
  negotiationBalanceReady?: boolean;
  hallModeAvailable?: boolean;
  hasActiveHallAd: boolean;
};

export function negotiationPaymentReady(readiness: {
  paymentMethodReady: boolean;
  hallSettlementMode?: "prepaid" | "legacy";
  negotiationBalanceReady?: boolean;
  hallModeAvailable?: boolean;
}): boolean {
  if (readiness.hallModeAvailable === false) return false;
  if (readiness.hallSettlementMode === "prepaid") return readiness.negotiationBalanceReady === true;
  return (
    (readiness.hallSettlementMode === undefined || readiness.hallSettlementMode === "legacy") &&
    readiness.paymentMethodReady === true
  );
}

export const NEGOTIATION_BALANCE_RULE = "Saldo de Negociações aberto";
export const PAYMENT_METHOD_RULE = "Método de pagamento configurado";
export const PAYMENT_READINESS_ERROR_RULE = "Método de pagamento: não foi possível verificar agora";

/** Why the last payment readiness read failed, if it did. */
export type PaymentReadinessProblem = "unavailable" | null;

/**
 * Label of the payment rule in the locked-item tooltip.
 *
 * The rule is the organization's `paymentMethodReady` from Enterprise, the
 * field the servers enforce, which names no payment rail. A failed read is
 * named as a failure instead of looking like a method was never configured
 * (the loaders render an error page for it, see paymentMethodGate.ts).
 */
export function paymentReadinessRuleLabel(problem: PaymentReadinessProblem): string {
  return problem ? PAYMENT_READINESS_ERROR_RULE : PAYMENT_METHOD_RULE;
}

export function negotiationSidebarRules(
  readiness: NegotiationSidebarReadiness,
  canView: boolean,
  tutorialComplete: boolean,
  paymentRuleLabel: string = PAYMENT_METHOD_RULE,
): Record<string, boolean> {
  return {
    "Cadastro da organização concluído": readiness.orgOnboardingComplete,
    "Logo da organização configurado": readiness.hasOrgAvatar,
    [readiness.hallModeAvailable === false
      ? "Saldo do Átrio: não foi possível verificar agora"
      : readiness.hallSettlementMode === "prepaid"
        ? NEGOTIATION_BALANCE_RULE
        : paymentRuleLabel]: negotiationPaymentReady(readiness),
    "Anúncio ativo no Átrio": readiness.hasActiveHallAd,
    "Permissão para visualizar essa página": canView,
    "Tutorial de negociação concluído": tutorialComplete,
  };
}
